module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiM2NDY0NjQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE5IDh2OGMwIDEuMTA1LS45NjQgMi0yLjE1NCAySDcuMTU0QzUuOTY0IDE4IDUgMTcuMTA1IDUgMTZWOGMwLTEuMTA1Ljk2NC0yIDIuMTU0LTJoOS42OTJDMTguMDM2IDYgMTkgNi44OTUgMTkgOHptLTEuMDc3IDJINi4wNzd2NmMwIC41NTIuNDgyIDEgMS4wNzcgMWg5LjY5MmMuNTk1IDAgMS4wNzctLjQ0OCAxLjA3Ny0xdi02eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-calendar.svg
// module id = Vapz
// module chunks = 0